export default "__VITE_ASSET__5sEmKd1T__"